import { Components, Theme, inputBaseClasses } from '@mui/material';
import { CornerSmall } from '../corners';
import { Content, Border } from '../color';
import getTransition from '../utilities/getTransition';
import ExpandMore from '../icons/ExpandMore';
import { selectClasses } from './types';
import { Spacing2, Spacing3 } from '../spacing';

declare module '@mui/material/Select' {
  interface SelectClasses {
    root: string
  }
}

export const MuiSelect: Components<Theme>['MuiSelect'] = {
  defaultProps: {
    IconComponent: ExpandMore,
  },
  styleOverrides: {
    root: {
      fieldset: {
        borderRadius: CornerSmall.borderRadius,
        borderColor: Border.default.main,
        borderStyle: 'solid',
        borderWidth: 1,
        ...getTransition(['borderColor'], 500),
      },
      [`.${inputBaseClasses.inputSizeSmall}`]: {
        lineHeight: '24px',
        padding: `${Spacing2} ${Spacing3}`,
      },
      [`.${selectClasses.placeholder}`]: {
        color: Content.tertiary,
      },
    },
  },
};
